module.exports = __webpack_public_path__ + "static/jrclg-b71b9d007a2d45c8ef48f6d2ba1e10f8.jpg";